import React from 'react';

import { Flex } from '@sopranodesign/pulse-components';
import { Embed } from '@sopranodesign/pulse-volt';

const EmbedDemo = () => (
  <Flex middle relative grow style={{ zIndex: 0 }} data-testid="embed-demo">
    <Embed start="/window/body/messages" />
  </Flex>
);

export default EmbedDemo;
